class BundleProgress {
  constructor(el) {
    this.el = el;
    this.container = el;
    this.bundlesContainer =
      this.container.closest("[data-promo-subscription-builder]") ||
      this.container.closest("[data-single-bundle-container]") ||
      this.container.closest("[data-bundles-container]") ||
      this.container.closest("[data-bundles-container-v2]");

    if (!this.container || !this.bundlesContainer) {
      return;
    }

    this.fillEl = this.el.querySelector("[data-progress-fill]");
    this.selectedCountEl = this.el.querySelector("[data-selected-count]");
    this.totalCountEl = this.el.querySelector("[data-total-count]");

    this.totalLimit = parseInt(this.container.dataset.totalLimit, 10) || 3;
    if (this.totalCountEl) {
      this.totalCountEl.textContent = this.totalLimit;
    }

    this.updateUI = this.updateUI.bind(this);
    this.init();
  }

  init() {
    this.bundlesContainer.addEventListener("change", this.updateUI);
    this.updateUI();
  }

  getActiveBundleId() {
    return this.bundlesContainer ? this.bundlesContainer.dataset.activeBundle : null;
  }

  getTotalSelectedCount() {
    const activeBundleId = this.getActiveBundleId();
    if (!activeBundleId) {
      return 0;
    }

    const flavours = this.bundlesContainer.querySelectorAll("[data-flavour-quantity]");
    let totalSelected = 0;
    flavours.forEach((flavour) => {
      if (flavour.dataset.bundleVariantId == activeBundleId) {
        totalSelected += parseInt(flavour.value);
      }
    });

    return totalSelected;
  }

  updateUI() {
    let selected = this.getTotalSelectedCount();
    if (selected > this.totalLimit) {
      selected = this.totalLimit;
    }

    if (this.selectedCountEl) {
      this.selectedCountEl.textContent = selected;
    }

    if (!this.fillEl) {
      return;
    }

    const percent = selected > 0 ? (selected / Math.max(1, this.totalLimit)) * 100 : 0;
    this.fillEl.style.width = `${percent}%`;
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const blocks = document.querySelectorAll("[data-bundle-progress]");
  blocks.forEach((block) => new BundleProgress(block));
});
